module.exports = __webpack_public_path__ + "img/contact_img_01.57e8f528.jpg";